import React from 'react';
import {Breakpoints, styled} from '@volkswagen-onehub/components-core';
import Skeleton from 'react-loading-skeleton';
import VehicleCardLayout from '../../layouts/VehicleCardLayout';
import { VehicleData } from '../../types';
import DividerTop from '../VehicleCard/card-grids/DividerTop';
import DividerBottom from '../VehicleCard/card-grids/DividerBottom';

const CardJellySkeleton = styled.div`
  grid-area: jelly;
  height: 100%;
`;

const CardStockSkeleton = styled.div`
  margin-top: ${(props) => props.theme.size.dynamic0040};
  grid-area: stock;
  width: 50%;
`;

const CardLikeSkeleton = styled.div`
  grid-area: like;
  margin-top: ${(props) => props.theme.size.dynamic0040};
  margin-right: ${(props) => props.theme.size.dynamic0120};
  display: flex;
  justify-content: flex-end;
`;

const CardModelSkeleton = styled.div`
  grid-area: model;
  margin-top: ${(props) => props.theme.size.dynamic0040};
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0020};
  width: 50%;
`;

const CardPriceSkeleton = styled.div`
  grid-area: price;
  margin-top: ${(props) => props.theme.size.dynamic0040};
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0020};
`;

const CardDescriptionSkeleton = styled.div`
  grid-area: description;
  margin-top: ${(props) => props.theme.size.static150};
`;

const CardColourSkeleton = styled.div`
  grid-area: colours;
  margin-top: ${(props) => props.theme.size.static150};
`;

const CardActionsSkeleton = styled.div`
  grid-area: actions;
  text-align: center;
  margin-bottom: ${(props) => props.theme.size.dynamic0020};

  @media screen and (min-width: ${Breakpoints.b960}px) {
    margin-bottom: 0;
  }
`;

const CardDealerSkeleton = styled.div`
  grid-area: dealer;
`;

const VehicleCardSkeleton = () => {
  return (
    <VehicleCardLayout vehicle={{} as VehicleData}>
      <CardJellySkeleton>
        <Skeleton height={'100%'} style={{borderRadius: 0}} />
      </CardJellySkeleton>

      <CardStockSkeleton>
        <Skeleton borderRadius={0} height={25} />
      </CardStockSkeleton>

      <CardLikeSkeleton>
        <Skeleton width={30} height={30} circle={true} />
      </CardLikeSkeleton>

      <CardModelSkeleton>
        <Skeleton height={50} borderRadius={0} />

        <Skeleton height={20} borderRadius={0} />
      </CardModelSkeleton>

      <CardPriceSkeleton>
        <Skeleton height={50} borderRadius={0} />

        <Skeleton height={20} borderRadius={0} />
      </CardPriceSkeleton>

      <DividerTop />

      <CardDescriptionSkeleton>
        <Skeleton style={{marginBottom: '5px'}} count={7} borderRadius={0} />
      </CardDescriptionSkeleton>

      <CardColourSkeleton>
        <Skeleton style={{marginBottom: '5px'}} count={2} borderRadius={0} />
      </CardColourSkeleton>

      <DividerBottom />

      <CardActionsSkeleton>
        <Skeleton
          style={{marginRight: '10px'}}
          count={2}
          inline={true}
          width={'45%'}
          height={40}
          borderRadius={50}
        />
      </CardActionsSkeleton>

      <CardDealerSkeleton>
        <Skeleton
          width={'50%'}
          style={{marginBottom: '5px'}}
          borderRadius={0}
          count={2}
        />
      </CardDealerSkeleton>
    </VehicleCardLayout>
  );
};

export default VehicleCardSkeleton;
